import axios from '../../network/axios'
import { INST_LIST, INST_LIST_REQUEST, CATEGORY_LIST } from '../types'

const state = {
	isFetching: false,
	items: [],
	categories: []
}

const getters = {
	institutions: (state) => state.items,
	listLoading: (state) => state.isFetching,
	categories: (state) => state.categories
}

const actions = {
	getInstitutions({ commit }) {
		return new Promise((resolve) => {
			commit(INST_LIST_REQUEST)
			axios.get('/institutions/random').then(({ data }) => {
				commit(INST_LIST, data)
				resolve()
			})
		})
	},
	searchInstitutions({ commit }, { query, filters }) {
		return new Promise((resolve, reject) => {
			commit(INST_LIST_REQUEST)
			axios
				.get(
					'/institutions/search?query=' +
						query +
						'&filters=' +
						filters
				)
				.then(({ data }) => {
					window.analytics.track('search_institution')
					commit(
						INST_LIST,
						data.hits.map((item) => item.document)
					)
					resolve()
				})
				.catch((err) => reject(err))
		})
	},
	getCategories({ commit }) {
		return new Promise((resolve, reject) => {
			axios
				.get('/institutions/categories')
				.then(({ data }) => {
					commit(CATEGORY_LIST, data)
					resolve()
				})
				.catch((err) => reject(err))
		})
	}
}

const mutations = {
	[INST_LIST_REQUEST](state) {
		state.isFetching = true
	},
	[INST_LIST](state, institutions) {
		state.isFetching = false
		state.items = institutions
	},
	[CATEGORY_LIST](state, cats) {
		state.categories = cats
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
